import { useEffect, useRef } from 'react';
import { Chart } from "chart.js";
import { MdSearch } from "react-icons/md"; // Importando a lupa

const ChartWidget = ({ 
    title, 
    data, 
    backgroundColor, 
    borderColor, 
    startDate, 
    endDate, 
    onDateChange,
    onSearch // Nova prop para ação de clique
}) => {
    const chartRef = useRef(null);
    const chartInstance = useRef(null);

    useEffect(() => {
        if (!chartRef.current || !data) return;

        const ctx = chartRef.current.getContext('2d');
        const labels = Object.keys(data);
        const values = Object.values(data);

        if (chartInstance.current) chartInstance.current.destroy();

        chartInstance.current = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: title,
                    data: values,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderWidth: 1,
                    borderRadius: 4,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: { legend: { display: false } },
                scales: {
                    y: { beginAtZero: true, grid: { borderDash: [2, 4] } },
                    x: { grid: { display: false }, ticks: { autoSkip: false, maxRotation: 45, minRotation: 45 } }
                }
            }
        });

        return () => {
            if (chartInstance.current) chartInstance.current.destroy();
        };
    }, [data, title, backgroundColor, borderColor]);

    return (
        <div className="flex flex-col h-full bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
            {/* CABEÇALHO */}
            <div className="drag-handle p-3 bg-slate-50 border-b border-slate-100 flex flex-col sm:flex-row justify-between items-center gap-2 cursor-move">
                <h3 className="font-bold text-gray-700 text-xs sm:text-sm truncate w-full sm:w-auto text-center sm:text-left">{title}</h3>
                
                {/* Controles de Data + Botão Pesquisar */}
                <div 
                    className="flex items-center gap-2 bg-white p-1 rounded-lg border border-slate-200 shadow-sm" 
                    onMouseDown={(e) => e.stopPropagation()} // Impede drag ao clicar aqui
                >
                    <input 
                        type="date" 
                        className="text-[10px] sm:text-xs bg-transparent outline-none text-gray-600 font-medium w-24 sm:w-auto"
                        value={startDate}
                        onChange={(e) => onDateChange('start', e.target.value)}
                    />
                    <span className="text-gray-300 text-[10px]">-</span>
                    <input 
                        type="date" 
                        className="text-[10px] sm:text-xs bg-transparent outline-none text-gray-600 font-medium w-24 sm:w-auto"
                        value={endDate}
                        onChange={(e) => onDateChange('end', e.target.value)}
                    />
                    
                    {/* Botão de Pesquisar */}
                    <button 
                        onClick={onSearch}
                        className="bg-custom_blue hover:bg-blue-600 text-white p-1.5 rounded-md transition-colors shadow-sm flex items-center justify-center"
                        title="Filtrar"
                    >
                        <MdSearch size={14} />
                    </button>
                </div>
            </div>

            <div className="flex-1 min-h-0 relative w-full p-4">
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
};

export default ChartWidget;